import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export function useAreas(
  officeId: string | null,
  parentId: string | null = null
) {
  const { api } = useTacticHooks();
  const {
    data: areas,
    error,
    isLoading,
    refetch: refetchAreas
  } = useQuery({
    queryKey: [
      "organizations.resourcesAll",
      officeId ?? "",
      ["area"],
      parentId ?? ""
    ],

    queryFn: async () => {
      const res = await api.client.organizations.getAllResources({
        officeId: officeId ?? "",
        types: ["area"],
        parentId
      });
      return res.result;
    },

    enabled: officeId !== null
  });
  const loading = isLoading;
  return { areas, error, loading, refetch: refetchAreas };
}
